export const SET_SUPPRESS_PON_ACTION = "SET_SUPPRESS_PON_ACTION";


// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/response-handler-launch-message-process/actions/actionTypes.ts